module.exports = __webpack_public_path__ + "static/grid-a-6e26d28e99ff3350ea354db9c78f844b.jpg";